// Copyright (c) 2022. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { BUY_BUTTON_CLASS_NAME } from "../../../../core/constants/className";
import { Product } from "../../../../../../io/hyperify/core/store/types/product/Product";
import { ProductPrice } from "../../../../../../io/hyperify/core/store/types/product/ProductPrice";
import { ReactNode, useCallback } from "react";
import { StoreCartService } from "../../../../../../io/hyperify/core/StoreCartService";
import { LogService } from "../../../../../../io/hyperify/core/LogService";
import { Button } from "../../../../../../io/hyperify/frontend/components/button/Button";
import { ButtonStyle } from "../../../../../../io/hyperify/core/frontend/button/ButtonStyle";
import "./BuyButton.scss";

const LOG = LogService.createLogger('BuyButton');

export interface BuyButtonProps {
    readonly className?: string;
    readonly product?: Product;
    readonly price?: ProductPrice;
    readonly label?: string;
    readonly children?: ReactNode;
    readonly style ?: ButtonStyle;
    readonly enabled ?: boolean;
}

export function BuyButton (props: BuyButtonProps) {
    const className = props?.className;
    const product = props?.product;
    const price = props?.price;
    const enabled = props?.enabled ?? true;
    const style = props?.style ?? ButtonStyle.PRIMARY;
    const onClick = useCallback(
        () => {
            if (enabled && product && price) {
                StoreCartService.addProduct(product, price);
                StoreCartService.setCartMenuOpen(true);
            } else {
                LOG.warn(`onClick: No product and/or price defined`);
            }
        },
        [
            product,
            price,
            enabled,
        ]
    );
    return (
        <Button
            enabled={enabled}
            style={style}
            click={onClick}
            className={
                BUY_BUTTON_CLASS_NAME
                + (className ? ` ${className}` : '')
            }
        >{props.children}</Button>
    );

}
